<template>
    <AdSection1
        :imageSrc="pic1Src"
        title="تبلیغات همسان؛ محتوایی برای جذب مخاطب"
        :text="`هدف اصلی تبلیغات همسان، جذب مخاطب با ارائه محتوایی متناسب و جذاب است.</br>
        Native Ads یا همان تبلیغات همسان با تأکید بر جذابیت و محتوای مرتبط، می تواند بازدیدکنندگان را به تعامل بیشتر با برند شما سوق دهد.`"
        imageAnimation="fade-right"
    >
    </AdSection1>

    <AdSection2
        :imageSrc="pic2Src"
        count="20,000,000,000+"
        text="تبلیغ همسان با آن کلیک"
    >
    </AdSection2>

    <AdSection3
        title="تبلیغات همسان"
        text="تبلیغات همسان به شکلی هوشمندانه و هماهنگ با محتوای صفحات وب، به معرفی برند، محصولات یا خدمات شما می پردازد. این هماهنگی توجه کاربران را به خود جلب کرده و آنها را به بازدید یا تعامل با محتوای شما دعوت می کند. همچنین هزینه کمتر، نسبت به سایر روش های کلیکی از مهم ترین ویژگی های این نوع از تبلیغات است."
        videoSrc="https://ifilo.net/embed/KhJowhq"
    >
    </AdSection3>

    <AdSection4
        :imageSrc="pic3Src"
        title="چرا تبلیغات همسان؟"
        :benefits="benefits"
    >
    </AdSection4>

    <AdContentCard
        :imageSrc="pic4Src"
        title="تبلیغات همسان منــاسب چه کسب و کارهایی است؟"
        text="تبلیغات همسان از آن دست تبلیغاتی است که آن کلیک آن را به کسب و کارهایی پیشنهاد می دهد که میخواهند تجربه کاربری بهتری ایجاد کنند و تعامل بیشتری با مخاطبان خود داشته باشند."
    >
    </AdContentCard>

    <AdTariff
    title="تعرفه تبلیغات همسان"
    text="در آن کلیک، با هر بودجه ای که دارید، می توانید تبلیغات همسان خود را ثبت کنید و از نتایج موثر آن بهره مند شوید. هزینه این تبلیغات بسته به نوع کمپین یا درخواست شما به ازای نمایش یا کلیک محاسبه می شود. "
    :imageSrc="pic5Src"
    >
    </AdTariff>

    <AdRoadmap></AdRoadmap>

    <AdConsult
    :text="`با تبلیغات همسان، برندتان را به روشی هوشمندانه به هزاران مخاطب معرفی کنید.</br>
     از همین لحظه کمپین خود را ثبت کرده یا برای مشاوره رایگان با تیم آن کلیک تماس بگیرید.`"
    >
    </AdConsult>

    <FAQ :faqList="faqList"></FAQ>
</template>

<script>
    import AdSection1 from './AdSection1';
    import AdSection2 from './AdSection2';
    import AdSection3 from './AdSection3';
    import AdSection4 from './AdSection4';
    import AdContentCard from './AdContentCard';
    import AdTariff from './AdTariff';
    import AdRoadmap from './AdRoadmap';
    import AdConsult from './AdConsult';
    import FAQ from './FAQ';

    import nativeAdPic1 from '@/assets/images/nativeAd-pic1.png';
    import nativeAdPic2 from '@/assets/images/nativeAd-pic2.png';
    import nativeAdPic3 from '@/assets/images/nativeAd-pic3.png';
    import nativeAdPic4 from '@/assets/images/nativeAd-pic4.png';
    import nativeAdPic5 from '@/assets/images/nativeAd-pic5.png';

    import {ref, inject, onMounted} from 'vue';
    export default {
        name: "NativeAds",
    components: {
    AdSection1,
    AdSection2,
    AdSection3,
    AdSection4,
    AdContentCard,
    AdTariff,
    AdRoadmap,
    AdConsult,
    FAQ,
    },
    setup() {

        const benefits = ref([
        "هماهنگی با محیط نمایش",
        "افزایش تعامل و اعتماد",
        "جذب ترافیک هدفمند",
        "اثرگذاری پایدار",
        ]);

        const faqList = ref([
        {
            q: "تبلیغات همسان چیست؟",
            a: "تبلیغات همسان، به تصاویر ثابتی گفته می شود که شبیه به سایر محتواهای وب سایت به مخاطبان نمایش داده می شود."
        },
        {
            q: " تبلیغات همسان برای چه افرادی مناسب است؟",
            a: "این نوع از تبلیغات برای کسب و کارهایی که به دنبال تعامل بیشتر با مخاطبان خود هستند، مناسب است."
        },
        {
            q: "هزینه ثبت تبلیغات همسان در آن کلیک چقدر است؟",
            a: `تعرفه تبلیغات همسان با توجه به درخواست شما به ازای کلیک یا نمایش محاسبه می شود. جزییات بیشتر: <a href="/tariff">تعرفه ثبت تبلیغات</a>`
        },
        {
            q: " برای ثبت تبلیغ همسان در آن کلیک چه کنیم؟",
            a: "ابتدا در آن کلیک ثبت نام کرده و پس از ایجاد کمپین، تبلیغتان را ثبت کنید."
        },
        ]);

        const updateMetaTag = inject('updateMetaTag');
        const updateOGTag = inject('updateOGTag');
        const updateCanonicalLink = inject('updateCanonicalLink');

        onMounted (() => {
            updateMetaTag('title', 'تبلیغات همسان | جذب مخاطب در سایت های پر بازدید | آن کلیک');
            updateMetaTag('description', 'تبلیغات همسان در آن کلیک، تجربه ای طبیعی برای کاربر. افزایش نرخ کلیک و تعامل با محتوای هماهنگ با محیط نمایش، مخصوص برندهای حرفه ای.');
            updateOGTag('title', 'تبلیغات همسان | جذب مخاطب در سایت های پر بازدید | آن کلیک');
            updateOGTag('description', 'تبلیغات همسان در آن کلیک، تجربه ای طبیعی برای کاربر. افزایش نرخ کلیک و تعامل با محتوای هماهنگ با محیط نمایش، مخصوص برندهای حرفه ای.');
            updateOGTag('type', 'website');
            updateOGTag('image', require('@/assets/images/onclick.png'));
            updateCanonicalLink('https://onclick.ir/ads/native');
        });

        return {
            pic1Src: nativeAdPic1,
            pic2Src: nativeAdPic2,
            pic3Src: nativeAdPic3,
            pic4Src: nativeAdPic4,
            pic5Src: nativeAdPic5,
            benefits,
            faqList,
        }

    }
};
</script>

<style scoped>

</style>

